// Recovered compiled webpack factory 23597. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      addRefreshMarkerToActiveParallelSegments: function () {
        return function e(t, r) {
          let [n, a, , i] = t;
          for (let s in (n.includes(o.PAGE_SEGMENT_KEY) &&
            "refresh" !== i &&
            ((t[2] = r), (t[3] = "refresh")),
          a))
            e(a[s], r);
        };
      },
      refreshInactiveParallelSegments: function () {
        return i;
      },
    }));
  let n = r(77609),
    a = r(32753),
    o = r(65360);
  async function i(e) {
    let t = new Set();
    await s({ ...e, rootTree: e.updatedTree, fetchedSegments: t });
  }
  async function s(e) {
    let {
        navigatedAt: t,
        state: r,
        updatedTree: o,
        updatedCache: i,
        includeNextUrl: l,
        fetchedSegments: u,
        rootTree: c = o,
        canonicalUrl: f,
      } = e,
      [, d, p, h] = o,
      _ = [];
    if (p && p !== f && "refresh" === h && !u.has(p)) {
      u.add(p);
      let e = (0, a.fetchServerResponse)(new URL(p, location.origin), {
        flightRouterState: [c[0], c[1], c[2], "refetch"],
        nextUrl: l ? r.nextUrl : null,
      }).then((e) => {
        let { flightData: r } = e;
        if ("string" != typeof r) for (let e of r) (0, n.applyFlightData)(t, i, i, e);
      });
      _.push(e);
    }
    for (let e in d) {
      let n = s({
        navigatedAt: t,
        state: r,
        updatedTree: d[e],
        updatedCache: i,
        includeNextUrl: l,
        fetchedSegments: u,
        rootTree: c,
        canonicalUrl: f,
      });
      _.push(n);
    }
    await Promise.all(_);
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
